export const calculationsTexts = {
  specifyNecessaryParameters: 'Пожалуйста, укажите необходимые параметры, чтобы мы смогли рассчитать стоимость займа',
  viewOffers: 'Смотреть предложения',
};
